var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.49 4.41l-4.2-3.267a2.1 2.1 0 00-2.58 0l-4.2 3.266A2.099 2.099 0 00.7 6.067V11.2c0 1.16.94 2.1 2.1 2.1h8.4a2.1 2.1 0 002.1-2.1V6.067c0-.648-.299-1.26-.81-1.658z",
    stroke: "#9495A0",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.273 7.527a1.8 1.8 0 11-2.544 2.545 1.8 1.8 0 012.544-2.545z",
    stroke: "#9495A0",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })));
}
export default SvgHome;